module.exports = __webpack_public_path__ + "static/key-menofwar-f6bfb7ec39f5a969b98f1ad90b1f286f.webp";